module.exports = __webpack_public_path__ + "media/svg/landing-fa-666dc457.svg";